export default __webpack_public_path__ + "static/media/bao.f9f52e7b.png";